/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminDebitOrCreditLevelPointRequestBody
 */
export interface AdminDebitOrCreditLevelPointRequestBody {
    /**
     * 
     * @type {string}
     * @memberof AdminDebitOrCreditLevelPointRequestBody
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof AdminDebitOrCreditLevelPointRequestBody
     */
    amount: number;
    /**
     * Setting this to true will add points, setting to false will credit points.
     * @type {boolean}
     * @memberof AdminDebitOrCreditLevelPointRequestBody
     */
    debit: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminDebitOrCreditLevelPointRequestBody
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDebitOrCreditLevelPointRequestBody
     */
    adminNote?: string;
}

/**
 * Check if a given object implements the AdminDebitOrCreditLevelPointRequestBody interface.
 */
export function instanceOfAdminDebitOrCreditLevelPointRequestBody(value: object): value is AdminDebitOrCreditLevelPointRequestBody {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('debit' in value) || value['debit'] === undefined) return false;
    return true;
}

export function AdminDebitOrCreditLevelPointRequestBodyFromJSON(json: any): AdminDebitOrCreditLevelPointRequestBody {
    return AdminDebitOrCreditLevelPointRequestBodyFromJSONTyped(json, false);
}

export function AdminDebitOrCreditLevelPointRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDebitOrCreditLevelPointRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'amount': json['amount'],
        'debit': json['debit'],
        'note': json['note'] == null ? undefined : json['note'],
        'adminNote': json['adminNote'] == null ? undefined : json['adminNote'],
    };
}

export function AdminDebitOrCreditLevelPointRequestBodyToJSON(json: any): AdminDebitOrCreditLevelPointRequestBody {
    return AdminDebitOrCreditLevelPointRequestBodyToJSONTyped(json, false);
}

export function AdminDebitOrCreditLevelPointRequestBodyToJSONTyped(value?: AdminDebitOrCreditLevelPointRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'amount': value['amount'],
        'debit': value['debit'],
        'note': value['note'],
        'adminNote': value['adminNote'],
    };
}

